/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validTelPhone(str) {
    const reg = /^1[3456789]\d{9}$/
    return reg.test(str)
}
